import React from 'react';
import MessageModal from 'messages/MessageModal';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { setFatalError } from 'current';

const NotEnoughDataForZonesError = () => {
  const error = useAppSelector((state) => state.current?.fatalError);
  const dispatch = useAppDispatch();

  const closeErrorModal = () => {
    dispatch(setFatalError());
  };

  return error ? (
    <div className='vra-loading-page__container' data-test-id='error-on-start-zone-generation'>
      <MessageModal
        actions={[{ textKey: 'button-text__close', action: () => closeErrorModal() }]}
        bodyText={error.message}
      />
    </div>
  ) : null;
};

export default NotEnoughDataForZonesError;
